(() => {
  'use strict';
  const marker = '_hipgaga_free_gift';
  const root = () => window.Shopify?.routes?.root || '/';
  const readConfig = () => {
    const nodes = [...document.querySelectorAll('[data-px-auto-gift-config]')];
    const node = nodes.find(n => n.dataset.productScope === 'true') || nodes[0];
    try { return JSON.parse(node?.textContent || '{}'); } catch (_) { return {}; }
  };
  const managed = item => item.properties?.[marker] === '79-v1';
  function plan(cart, config, rate = 1) {
    const gifts = (config.gifts || []).filter(gift => Number(gift.id) > 0);
    const ids = new Set(gifts.map(g => Number(g.id)));
    const eligibleIds = new Set((config.eligibleProductIds || []).map(Number));
    const subtotal = cart.items.filter(i => !managed(i) && !ids.has(Number(i.variant_id)) && eligibleIds.has(Number(i.product_id)))
      .reduce((sum, i) => sum + Number(i.original_line_price || 0), 0);
    const validRate = Number.isFinite(rate) && rate > 0;
    const qualified = Boolean(config.enabled && gifts.length > 0 && ids.size === gifts.length && validRate && subtotal >= Math.round(config.thresholdUSD * rate));
    const updates = {};
    const adds = [];
    for (const item of cart.items.filter(managed)) {
      if (!qualified || !ids.has(Number(item.variant_id))) updates[item.key] = 0;
    }
    if (qualified) for (const gift of gifts) {
      const own = cart.items.filter(i => managed(i) && Number(i.variant_id) === Number(gift.id));
      const paidQuantity = cart.items.filter(i => !managed(i) && Number(i.variant_id) === Number(gift.id)).reduce((s, i) => s + i.quantity, 0);
      const want = paidQuantity ? 0 : 1;
      own.forEach((item, index) => { const target = index === 0 ? want : 0; if (item.quantity !== target) updates[item.key] = target; });
      if (want && !own.length && gift.available) adds.push({ id: Number(gift.id), quantity: 1, properties: { [marker]: '79-v1' } });
    }
    return { qualified, subtotal, updates, adds };
  }
  // The planner has no network side effects and is also used by regression tests.
  if (typeof module !== 'undefined' && module.exports) { module.exports = { plan, managed }; return; }
  const request = async (path, body) => {
    const response = await fetch(root() + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Gift cart update unavailable');
    return response.json();
  };
  let inFlight = null;
  const reconcile = async () => {
    let cart = await request('cart.js');
    const signature = value => JSON.stringify(value.items.map(i => [i.key, i.quantity, i.final_line_price]));
    const before = signature(cart);
    const config = readConfig();
    // Ajax prices use the customer's currency; never compare CAD/EUR cents directly to USD cents.
    const rate = cart.currency === 'USD' ? 1 : Number(window.Shopify?.currency?.rate);
    const next = plan(cart, config, rate);
    let changed = false;
    if (Object.keys(next.updates).length) { cart = await request('cart/update.js', { updates: next.updates }); changed = true; }
    if (next.adds.length) {
      try { await request('cart/add.js', { items: next.adds }); changed = true; }
      catch (_) { /* An unavailable gift must never prevent purchase of the main product. */ }
      cart = await request('cart.js');
    }
    // Shopify, rather than the theme, determines whether these lines are genuinely free.
    const unpaidGifts = cart.items.filter(i => managed(i) && Number(i.final_line_price) !== 0);
    if (unpaidGifts.length) {
      cart = await request('cart/update.js', { updates: Object.fromEntries(unpaidGifts.map(i => [i.key, 0])) });
      changed = true;
    }
    changed = signature(cart) !== before;
    document.querySelectorAll('[data-cart-count]').forEach(n => { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; });
    document.dispatchEvent(new CustomEvent('hipgaga:gifts:updated', { detail: { cart, qualified: next.qualified, changed } }));
    return { cart, changed };
  };
  const sync = () => {
    if (inFlight) return inFlight.then(() => sync());
    const task = () => reconcile();
    inFlight = (navigator.locks ? navigator.locks.request('hipgaga-auto-gifts', task) : task()).finally(() => { inFlight = null; });
    return inFlight;
  };
  window.HipgagaGifts = { sync, managed };
  document.addEventListener('DOMContentLoaded', () => {
    if (window.Shopify?.designMode) return;
    sync().then(({ changed }) => { if (changed && document.querySelector('.cart-page-section')) location.reload(); }).catch(() => {});
    // The cart-page form must await reconciliation before submitting checkout.
    document.addEventListener('submit', async event => {
      const form = event.target;
      if (form.matches('form[data-skip-ajax-cart="true"][action*="/cart/add"]') && form.querySelector('[name="return_to"]')?.value === '/checkout') {
        event.preventDefault();
        const button = event.submitter;
        if (button) button.disabled = true;
        try {
          const response = await fetch(root() + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Unable to add item');
          await sync().catch(() => {});
          location.href = root() + 'checkout';
        } catch (_) { if (button) button.disabled = false; }
        return;
      }
      if (!form.matches('.cart-page-section form[action*="/cart"]') || form.dataset.pxGiftChecked === 'true') return;
      event.preventDefault();
      const submitter = event.submitter;
      const submit = () => {
        // Quantities were already saved through Ajax. Old form indexes can point at a newly added gift.
        if (submitter?.name === 'checkout') form.querySelectorAll('[name="updates[]"]').forEach(input => { input.disabled = true; });
        form.dataset.pxGiftChecked = 'true';
        form.requestSubmit(submitter || undefined);
      };
      try { await sync(); submit(); }
      catch (_) { submit(); }
    }, true);
  });
  window.addEventListener('pageshow', event => { if (event.persisted) sync().catch(() => {}); });
})();
